import React from 'react';

import { CDN_URL, getCdnImageUrl } from '@utils/cloudflare';

import ImageLoaded from '@components/common/ImageLoaded/ImageLoaded';

type PartnerLogoProps = {
  imageUrl: string;
  backgroundUrl: string;
  ctaUrl: string;
};

export default function PartnerLogo({ imageUrl, backgroundUrl, ctaUrl }: PartnerLogoProps) {
  const imageFromCDN = getCdnImageUrl(720, imageUrl, CDN_URL);
  const backgroundImg = backgroundUrl && getCdnImageUrl(720, backgroundUrl, CDN_URL);
  return (
    <div
      id="partner-logo"
      className="flex justify-center relative items-center h-72px bg-white w-full border-b border-rp-primary-redesign pl-4 pr-4"
    >
      {ctaUrl ? (
        <a href={ctaUrl} className="flex" target="_blank" rel="noreferrer">
          <ImageLoaded
            url={imageFromCDN}
            classes="z-10"
            height="32"
            objectFit="contain"
            alt="partner logo"
          />
        </a>
      ) : (
        <ImageLoaded
          url={imageFromCDN}
          classes="z-10"
          height="32"
          objectFit="contain"
          alt="partner logo"
        />
      )}
      {backgroundImg && (
        <ImageLoaded
          url={backgroundImg}
          classes="absolute w-full h-full"
          layout="fill"
          objectFit="cover"
          alt="background image"
        />
      )}
    </div>
  );
}
